import isEmpty from 'lodash-es/isEmpty'
import map from 'lodash-es/map'
import React from 'react'

import { PriceString, Timeline } from '@fourthwall/components'
import type { OrderOffer } from '@fourthwall/services/dist/models/order'

import { getVariants } from '../../../utils/variants'
import { ProductsList } from '../ProductsList'
import * as S from './styled'
import type { OrderPopoverProps } from './types'

const renderProduct = ({ quantity, offer, variant }: OrderOffer) => (
  <ProductsList.Item
    key={variant.id}
    image={offer.primaryImage?.thumbnail.url}
    name={offer.name}
    variants={getVariants(variant)}
    quantity={quantity}
  />
)

const OrderPopover = ({
  title,
  products,
  donation,
  events,
  $padding = 'medium',
}: OrderPopoverProps) => {
  const renderDonation = () => {
    if (donation) {
      return (
        <ProductsList.Item
          name={
            <>
              <PriceString value={donation} /> Donation
            </>
          }
          donation
        />
      )
    }

    return null
  }

  const renderProducts = () => {
    if (products) {
      return (
        <ProductsList size="small">
          {map(products, renderProduct)}
          {renderDonation()}
        </ProductsList>
      )
    }

    return null
  }

  const renderTimeline = () => {
    if (!events) {
      return null
    }

    if (isEmpty(events)) {
      return <S.EmptyNotice>There are no events yet to display for this order.</S.EmptyNotice>
    }

    return (
      <S.TimelineContainer>
        <Timeline events={events} />
      </S.TimelineContainer>
    )
  }

  return (
    <S.Container $padding={$padding}>
      {title && <S.Title>{title}</S.Title>}
      {renderProducts()}
      {renderTimeline()}
    </S.Container>
  )
}

const EnhancedOrderPopover = React.memo(OrderPopover)

export { EnhancedOrderPopover as OrderPopover }
